// export const BASE_URL = "http://163.172.106.97:1001/";
export const BASE_URL = "https://superviseur-backend.satisworld.online/";
//export const BASE_URL = "http://127.0.0.1:8000/";
export const CDN_BASE_URL = "https://superviseur-backend.satisworld.online/";